// extracted by mini-css-extract-plugin
module.exports = {"main_content":"subFeatureItem__main_content___2bOE_","desktop":"subFeatureItem__desktop___2DmKV","content":"subFeatureItem__content___1CuPA","image":"subFeatureItem__image___1j5zt","mobile":"subFeatureItem__mobile___39fOu","text":"subFeatureItem__text___3eFhy","links":"subFeatureItem__links___2z3tW","main_content__h1":"subFeatureItem__main_content__h1___1OgHx"};
    if(module.hot) {
      // 1680611715520
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  